<app-quick-actions>
  <a class="atmos-btn atmos-btn--sm" routerLinkActive="atmos-btn--active" routerLink="/editor/spirit-tree"><mat-icon>account_tree</mat-icon> Spirit tree editor</a>
  <a class="atmos-btn atmos-btn--sm" routerLinkActive="atmos-btn--active" routerLink="/editor/todo"><mat-icon>checklist</mat-icon> Todo</a>
  <a class="atmos-btn atmos-btn--sm" routerLinkActive="atmos-btn--active" routerLink="/editor/dye"><mat-icon>palette</mat-icon> Dyes</a>
  <a class="atmos-btn atmos-btn--sm" routerLinkActive="atmos-btn--active" routerLink="/editor/outfit-shrine"><mat-icon>checkroom</mat-icon> Outfit Shrine</a>
</app-quick-actions>
<div class="editor-content">
  <router-outlet></router-outlet>
</div>
